/** Stable ephemeral id for client-only draft rows (import previews, sortable lists). */
export function newClientKey(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
